<template>
    <div class="display-config">
        <div class="d-flex flex-column">
            <h2>{{ $t("fastWizard.customizeLiveChat") }}</h2>
            <span>{{ $t("fastWizard.createBrandedExperience") }}</span>
            <h4 class="mt-2">{{ $t("fastWizard.chatColor") }}</h4>
            <span>{{ $t("fastWizard.chooseChatColor") }}</span>
            <div class="colorPalette">
                <div class="palette servquick" @click="changeTheme('servquick')">
                    <span>
                        {{
                            $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "servquick" ? "✓" : ""
                        }}
                    </span>
                </div>
                <div class="palette mango" @click="changeTheme('mango')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "mango" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette blue" @click="changeTheme('blue')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "blue" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette purple" @click="changeTheme('purple')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "purple" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette pink" @click="changeTheme('pink')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "pink" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette green" @click="changeTheme('green')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "green" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette red" @click="changeTheme('red')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "red" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette orange" @click="changeTheme('orange')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "orange" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette yellow" @click="changeTheme('yellow')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "yellow" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette black" @click="changeTheme('black')">
                    <span>
                        {{ $_.get(settings, "chatCustomizationSettings.preferredThemeColor") === "black" ? "✓" : "" }}
                    </span>
                </div>
            </div>
            <h4 class="mt-2">{{ $t("fastWizard.chatBubble") }}</h4>
            <span>{{ $t("fastWizard.selectBubble") }}</span>
            <div class="bubble-palette">
                <span class="bubble-item" @click="() => changeBubbleWithIndex('1')"><Bubble1 /></span>
                <span class="bubble-item" @click="() => changeBubbleWithIndex('2')"><Bubble2 /></span>
                <span class="bubble-item" @click="() => changeBubbleWithIndex('3')"><Bubble3 /></span>
                <span class="bubble-item" @click="() => changeBubbleWithIndex('4')"><Bubble4 /></span>
                <span class="bubble-item" @click="() => changeBubbleWithIndex('5')"><Bubble5 /></span>
                <span class="bubble-item" @click="() => changeBubbleWithIndex('6')"><Bubble6 /></span>
                <span class="bubble-item" @click="() => changeBubbleWithIndex('7')"><Bubble7 /></span>
                <span class="bubble-item" @click="() => changeBubbleWithIndex('8')"><Bubble8 /></span>
            </div>
            <h4 class="mt-2">{{ $t("fastWizard.chatBubbleColor") }}</h4>
            <span>{{ $t("fastWizard.selectChatBubbleColor") }}</span>
            <div class="bubbleColorPalette">
                <div class="palette blue" @click="changeBubbleColor('#0cbaba')">
                    <span>
                        {{ $_.get(settings, "bubble.bubbleColor") === "#0cbaba" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette purple" @click="changeBubbleColor('#2b004a')">
                    <span>
                        {{ $_.get(settings, "bubble.bubbleColor") === "#2b004a" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette pink" @click="changeBubbleColor('#b3004d')">
                    <span>
                        {{ $_.get(settings, "bubble.bubbleColor") === "#b3004d" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette green" @click="changeBubbleColor('#006319')">
                    <span>
                        {{ $_.get(settings, "bubble.bubbleColor") === "#006319" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette red" @click="changeBubbleColor('#910704')">
                    <span>
                        {{ $_.get(settings, "bubble.bubbleColor") === "#910704" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette orange" @click="changeBubbleColor('#eea849')">
                    <span>
                        {{ $_.get(settings, "bubble.bubbleColor") === "#eea849" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette yellow" @click="changeBubbleColor('#a3a007')">
                    <span>
                        {{ $_.get(settings, "bubble.bubbleColor") === "#a3a007" ? "✓" : "" }}
                    </span>
                </div>
                <div class="palette black" @click="changeBubbleColor('#0d2226')">
                    <span>
                        {{ $_.get(settings, "bubble.bubbleColor") === "#0d2226" ? "✓" : "" }}
                    </span>
                </div>
                <div class="picker">
                    {{
                        [
                            "#0cbaba",
                            "#2b004a",
                            "#b3004d",
                            "#006319",
                            "#910704",
                            "#eea849",
                            "#a3a007",
                            "#0d2226",
                        ].includes(bubbleColor)
                            ? $t("fastWizard.customSelection")
                            : "✓ " + $t("fastWizard.customSelection")
                    }}
                    <color-picker v-model="picker" :position="{ left: 0, top: '-400px' }" class="bubbleColorInput">
                    </color-picker>
                </div>
            </div>
        </div>
        <div class="preview ml-5">
            <LivePreview />
        </div>
    </div>
</template>

<script>
import log2 from "../../utils/log2";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage } from "../../utils/socketStream";
import Bubble1 from "../../components/svg/bubbles/Bubble1";
import Bubble2 from "../../components/svg/bubbles/Bubble2";
import Bubble3 from "../../components/svg/bubbles/Bubble3";
import Bubble4 from "../../components/svg/bubbles/Bubble4";
import Bubble5 from "../../components/svg/bubbles/Bubble5";
import Bubble6 from "../../components/svg/bubbles/Bubble6";
import Bubble7 from "../../components/svg/bubbles/Bubble7";
import Bubble8 from "../../components/svg/bubbles/Bubble8";
import _ from "lodash";
import LivePreview from "./LivePreview";

const log = log2("DisplayConfig");
export default {
    name: "DisplayConfig",
    components: {
        Bubble1,
        Bubble2,
        Bubble3,
        Bubble4,
        Bubble5,
        Bubble6,
        Bubble7,
        Bubble8,
        LivePreview,
    },
    data() {
        return {
            iframeLoading: true,
            newIcon: null,
            preDefined: "1",
            customBubbleColor: "teal",
            previewLoading: false,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
        bubbleColor: {
            get() {
                log("bubbleColor", { ...this.settings });
                return _.get(this.settings, "bubble.bubbleColor") || "#000000";
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "bubble.bubbleColor",
                    value: value,
                });
                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        picker: {
            get() {
                return this.customBubbleColor;
            },
            set: _.debounce(function (value) {
                this.customBubbleColor = value;
            }, 300),
        },
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        rgbToHex(color) {
            return color;
        },
        bubbleIcon() {
            let { customIcon } = this.settings.bubble;
            if (this.newIcon || customIcon) {
                let asset = this.newIcon || customIcon;
                return asset.v2Format && asset.cdnUrl
                    ? asset.cdnUrl
                    : `https://static.supsis.live/${asset.path + asset._id}${asset.ext ? "." + asset.ext : ""}`;
            }
            return undefined;
        },
        applySettings(newSettings) {
            log("applySettings", newSettings);
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
        changeTheme(selectedTheme) {
            const newSettings = this.setSettingValue({
                setting: "chatCustomizationSettings.preferredThemeColor",
                value: selectedTheme,
            });

            if (newSettings.then) {
                newSettings.then((x) => this.applySettings(x));
            } else {
                this.applySettings(newSettings);
            }
        },
        async changeBubbleWithIndex(index) {
            log("changeBubbleWithIndex", index);
            const newSettings = await this.setSettingValue({
                setting: "bubble.preDefined",
                value: index,
            });

            this.applySettings(newSettings);
        },
        async changeBubbleColor(color) {
            log("changeBubbleColor", color);
            const newSettings = await this.setSettingValue({
                setting: "bubble.bubbleColor",
                value: color,
            });
            this.applySettings(newSettings);
        },
    },
    watch: {
        current(val) {
            log("current changed", val);
        },
        customBubbleColor(val) {
            this.changeBubbleColor(val);
        },
        settings: {
            handler: function (newSettings) {
                const index = _.get(newSettings, "bubble.preDefined");
                if (this.preDefined !== index) this.preDefined = index;
                if (_.get(newSettings, "bubble.bubbleColor")) {
                    const predefined = [
                        "#0cbaba",
                        "#2b004a",
                        "#b3004d",
                        "#006319",
                        "#910704",
                        "#eea849",
                        "#a3a007",
                        "#0d2226",
                    ].includes(newSettings.bubble.bubbleColor);
                    if (!predefined) {
                        this.customBubbleColor = newSettings.bubble.bubbleColor;
                    }
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.wizard-footer {
    margin-top: 28px !important;
}
</style>
